// 첨부 파일의 겉모습 — 확장자별 아이콘·색·라벨. 바닐라 app.js 의 fileKindOf 이식.
//
// 각 도구의 관례색(엑셀 초록·PDF 빨강·워드 파랑)을 따르고, 모르는 형식은 회색으로
// 둔다 — 억지 색보다 낫다. 색은 CSS(.msg-file.f-xls 등)가 클래스로 입힌다.
//
// tabular = 우측 패널 그리드로 열 수 있는 형식. 이것만 클릭 가능하게 한다.

export type FileFace = {
  /** CSS 클래스 (f-xls · f-pdf · f-doc · f-ppt · f-img · f-etc) */
  cls: string;
  /** 아이콘 키 — React 는 lucide 를 쓰지 않으므로 인라인 SVG 로 매핑한다 */
  icon: "sheet" | "file-text" | "file-type" | "presentation" | "image" | "paperclip";
  /** 표 뷰어로 열 수 있는가 (엑셀·CSV·TSV) */
  tabular: boolean;
  label: string;
};

export function fileFace(name: string): FileFace {
  const s = (name || "").toLowerCase();
  if (/\.(csv|tsv)$/.test(s)) return { cls: "f-xls", icon: "sheet", tabular: true, label: "CSV" };
  if (/\.(xlsx|xlsm|xls)$/.test(s)) return { cls: "f-xls", icon: "sheet", tabular: true, label: "엑셀" };
  if (/\.pdf$/.test(s)) return { cls: "f-pdf", icon: "file-text", tabular: false, label: "PDF" };
  if (/\.(docx|doc|hwp|hwpx)$/.test(s)) return { cls: "f-doc", icon: "file-type", tabular: false, label: "문서" };
  if (/\.(pptx|ppt|key)$/.test(s)) return { cls: "f-ppt", icon: "presentation", tabular: false, label: "프레젠테이션" };
  if (/\.(png|jpe?g|webp|gif|svg)$/.test(s)) return { cls: "f-img", icon: "image", tabular: false, label: "이미지" };
  return { cls: "f-etc", icon: "paperclip", tabular: false, label: "파일" };
}
